import useSWR from "swr";

import { getServerUrl } from "config/backend";
import { CONFIG_UPDATE_INTERVAL } from "lib/timeConstants";

type SystemMetricsResponse = {
  dailyVolume?: string;
  totalVolume?: string;
  weeklyFees?: string;
  epochFees?: string;
  totalFees?: string;
  totalUsers?: string | number;
  updatedAt?: string;
};

export type SystemMetrics = {
  dailyVolume: bigint;
  totalVolume: bigint;
  weeklyFees: bigint;
  epochFees: bigint;
  totalFees: bigint;
  totalUsers: bigint;
  updatedAt?: string;
};

function toBigInt(value?: string | number) {
  if (value === undefined || value === null) return 0n;
  if (typeof value === "number") return BigInt(value);
  if (value === "") return 0n;
  return BigInt(value);
}

export default function useSystemMetrics(chainId: number) {
  const url = getServerUrl(chainId, "/system_metrics");

  const { data } = useSWR<any>([url], {
    fetcher: (args: [string]) => fetch(...args).then((res) => res.json()),
    refreshInterval: CONFIG_UPDATE_INTERVAL,
  });

  if (!data) return undefined;

  let metricsData: SystemMetricsResponse = {};

  if (Array.isArray(data)) {
    data.forEach((item: any) => {
      if (item.key) {
        metricsData[item.key as keyof SystemMetricsResponse] = item.value;
      }
    });
  } else {
    metricsData = data;
  }

  return {
    dailyVolume: toBigInt(metricsData.dailyVolume),
    totalVolume: toBigInt(metricsData.totalVolume),
    weeklyFees: toBigInt(metricsData.weeklyFees),
    epochFees: toBigInt(metricsData.epochFees),
    totalFees: toBigInt(metricsData.totalFees),
    totalUsers: toBigInt(metricsData.totalUsers),
    updatedAt: metricsData.updatedAt,
  } as SystemMetrics;
}
